<template>
  <nav class="navbar sticky-top navbar-expand-lg navbar-light">
    <div class="navbar-brand logo"><img src="../assets/images/pic_logo.png" alt="logo.png"></div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse collapse" id="navbarNav">
      <ul class="navbar-nav m-auto">
        <li class="nav-item">
          <a class="nav-link" v-smooth-scroll="{ offset: (windowWidth > 580) ? -60 : -200 }" href="#characteristic">產品特色</a>
        </li>
        <li class="nav-item my-auto mx-3 none">
          |
        </li>
        <li class="nav-item">
          <a class="nav-link"  v-smooth-scroll="{ offset: (windowWidth > 580) ? -90 : -240 }" href="#content">主題內容</a>
        </li>
        <li class="nav-item my-auto mx-3 none">
          |
        </li>
        <li class="nav-item">
          <a class="nav-link" v-smooth-scroll="{ offset: (windowWidth > 580) ? -50 : -180 }" href="#app_download">軟體下載</a>
        </li>
        <!-- <li class="nav-item my-auto mx-3 none">
          |
        </li> -->
        <!-- <li class="nav-item">
          <a class="nav-link" v-smooth-scroll="{ offset: (windowWidth > 580) ? 0 : -150  }"  href="#teacher_login" >教師登入</a>
        </li> -->
      </ul>
    </div>
  </nav>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Navbar',
  data () {
    return {
      windowWidth: $(window).width()
    }
  },
  mounted () {
    const toggle = document.querySelector('.navbar-toggler')
    if ($(window).width() < 580) {
      $('.nav-link').on('click', function () {
        toggle.click()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .logo {
    width: 50%;
    img {
      height: auto;
      max-width: 100%;
    }
  }
  nav {
    background-color: #fff;
    box-shadow:4px 4px 3px rgba(20%,20%,40%,0.2);
  }
  @media screen and (max-width: 1000px) {
    .none {
      display: none;
    }
  }
</style>
